var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-2" },
    [
      _c(
        "div",
        { staticClass: "row match-height pl-05 pr-05" },
        _vm._l(_vm.resources, function (resource, index) {
          return _c(
            "div",
            {
              key: _vm.infiniteId + index,
              class:
                "p-05 col-12 col-sm-6 col-md-4" +
                (_vm.service_settings.max_column_count === 4
                  ? " col-lg-3"
                  : ""),
            },
            [
              _c("resources-infinite-scroll-card", {
                attrs: {
                  resource: resource,
                  service_settings: _vm.service_settings,
                },
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "infinite-loading",
        {
          attrs: { identifier: _vm.infiniteId },
          on: {
            distance: function ($event) {
              1
            },
            infinite: _vm.infiniteHandler,
          },
        },
        [
          _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "no-results" }, slot: "no-results" }, [
            _vm._v(_vm._s(_vm.__("resource.lms.no_courses_yet"))),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }